import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class GeoDistrictFilter extends BaseFilter {
    public description: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return GeoDistrictFilter;
    }
}
